import {useNavigate} from 'react-router-dom'
import {fetchUserAccountDetailsAsync} from 'src/redux/actions/accountActions'
import {useAppDispatch} from 'src/redux/storeHooks'
import {performAdminSessionExpiredLogout} from 'src/utils/adminSessionExpiredLogout'
import {endImpersonation, hasValidAdminSnapshot} from 'src/utils/impersonationTokens'

export function useReturnToAdmin() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const returnToAdmin = async () => {
    if (!hasValidAdminSnapshot()) {
      performAdminSessionExpiredLogout(dispatch)
      return
    }

    const restored = endImpersonation()
    if (!restored) {
      performAdminSessionExpiredLogout(dispatch)
      return
    }

    await dispatch(fetchUserAccountDetailsAsync())
    navigate('/dashboard', { replace: true })
    document.location.reload()
  }

  return {
    returnToAdmin,
    canReturnToAdmin: hasValidAdminSnapshot(),
  }
}
